import React, { memo } from "react";
import { ItemsMainProps } from "../type";
// import LazyLoadImageComponent from "core/components/LazyLoadImage";
import { useRecipe } from "modules/Ingredients/hooks/recipe";

const EnrichmentCard: React.FC<ItemsMainProps> = ({
  title,
  description,
  thumbnail,
  flavor_items,
}) => {
  const { goToRecipeSuggession } = useRecipe()

  const handleClick = () => {
    goToRecipeSuggession(flavor_items.map((item: any) => String(item.id)), false)
    // goToRecipeSuggession([])
  }

  return (
    <article
      className={`min-w-[120px] max-w-[120px] min-h-[160px] px-1 pt-[10px] pb-[9px] rounded-lg text-white border border-[#EEEEEE]`} //${background} 
      onClick={handleClick}
    >
      <h3 className="text-sm font-bold text-[#111111] text-center leading-[16px] min-h-[32px]" dangerouslySetInnerHTML={{ __html: title }}>
      </h3>
      <div className="flex justify-center py-[5px]">
        {/* <LazyLoadImageComponent
          alt={`${title}`}
          className="object-cover self-center max-w-full rounded-full aspect-square w-[68px] h-[68px]"
          src={thumbnail}
        /> */}
        {thumbnail}
      </div>
      <div className="text-[8px] px-1 text-[#777777] text-center">
        {/* {hash_tags.map((tag: string, index: number) => (
          <span key={index} className="my-auto mr-[6px] text-[8px] text-[#777777]">
            #{tag}{" "}
          </span>
        ))} */}
         <span className="my-auto mr-[6px] text-[10px] text-[#777777] text-center" dangerouslySetInnerHTML={{ __html: description }}>
        </span>
      </div>
    </article>
  );
};

export default memo(EnrichmentCard);
